<template>
  <div class="index">
    <div style="margin-bottom: 20pt;">
      <router-link to="/detail/1159869617255812&330100"
        >分享楼盘详情</router-link
      >
      | <router-link to="/info/2137&47">新闻</router-link> |
      <router-link to="/shareInfo/2137&330100">分享新闻</router-link> |
      <router-link
        to="/contrast/1159869617255812,25159988998466087,1159869617255812"
        >分享对比</router-link
      >
    </div>
    <div style="margin-bottom: 10pt;">
      <router-link to="/advertise/1">app内嵌广告(视频)</router-link> |
      <router-link to="/advertise/3">app内嵌广告(文字)</router-link> |
      <router-link to="/test">测试同步滑动</router-link>
    </div>
    <div style="margin-bottom: 10pt;">
      <router-link to="/rookieStrategy">新手攻略</router-link> |
      <router-link to="/abortPlatform">关于平台</router-link> |
      <router-link to="/invite/30">邀请有礼</router-link> |
      <router-link to="/introduces">平台介绍</router-link>
    </div>
    <div style="margin-bottom: 10pt;">
      <router-link to="/serviceAgreement">服务协议</router-link> |
      <router-link to="/faceToFace/30">面对面邀请</router-link> |
      <router-link to="/inviteRegister/30">邀请注册</router-link> |
      <router-link to="/vipService">会员服务</router-link>
    </div>
    <div style="margin-bottom: 10pt;">
        <router-link to="/insureService">保险服务</router-link> |
        <router-link to="/countDownload">下载量统计</router-link> |
        <router-link to="/inviteNew">邀请有礼New</router-link> |
        <router-link to="/InviteRegisterNew">邀请注册New</router-link> |
    </div>
    <div style="margin-bottom: 10pt;">
        <router-link to="/privacy_policy">隐私政策</router-link> |
        <router-link to="/DyInformation">抖音信息</router-link> |
        <router-link to="/rightDetail">权益详情</router-link> |
        <router-link to="/VipServer">会员服务协议</router-link> |
    </div>
    <div style="margin-bottom: 10pt;">
        <router-link to="/ActivityRules">活动规则</router-link> |
        <router-link to="/MerchantsRights">招商权益</router-link> |
        <router-link to="/PayRules">支付协议</router-link> |
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
};
</script>

<style lang="sass" scoped>
.index
  text-align: center
  margin-top: 200px
</style>
